
import { initializeApp } from "firebase/app";

const firebaseConfig = {
apiKey: process.env.REACT_APP_API_KEY,
authDomain: process.env.REACT_APP_AUTH_DOMAIN,
databaseURL: process.env.REACT_APP_DATABASE_URL,
projectId: process.env.REACT_APP_PROJECT_ID,
storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
messagingSenderId: process.env.REACT_APP_MESSAGİNG_SENDER_ID,
appId: process.env.REACT_APP_APP_ID,

};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
export default firebase;